// Auth Phase 1 (P1-B): the ONE place the API and WebSocket origins are decided.
// Every client, service, page and socket imports from here — no more
// per-file hostnames.
//
//   development (CRA dev server)  → '' (relative; rides package.json "proxy")
//   production build on localhost → http://localhost:5001 (the local backend)
//   production                    → https://api.gvcbus.com  (P1-0, same-site
//                                   with portal.gvcbus.com so the httpOnly
//                                   refresh cookie is first-party)
//
// REACT_APP_API_URL / REACT_APP_WS_URL override everything (build-time).

const isDev = process.env.NODE_ENV === 'development';
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalhost = host === 'localhost' || host === '127.0.0.1';

export const API_ORIGIN = process.env.REACT_APP_API_URL
  || (isDev ? '' : (isLocalhost ? 'http://localhost:5001' : 'https://api.gvcbus.com'));

const devWs = () => {
  if (typeof window === 'undefined') return '';
  const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${window.location.host}/ws`; // dev server proxies /ws
};

export const WS_URL = process.env.REACT_APP_WS_URL
  || (isDev ? devWs() : (isLocalhost ? 'ws://localhost:5001/ws' : 'wss://api.gvcbus.com/ws'));

// WebSocket close codes the server uses (backend/services/sessionRegistry.js)
export const WS_CLOSE_REVOKED = 4401;       // session revoked / deactivated: do not reconnect
export const WS_CLOSE_TOKEN_EXPIRED = 4408; // access token expired: refresh and reconnect
